<template>
  <div class="admin-dev-tools">
    <!--
    <button type="button" class="button button-secondary--small" @click="open = true">
      Dev tools (refill)
    </button>
    -->

    <div class="modal__wrapper" v-if="open">
      <div class="modal__screen" @click.prevent="close"></div>
      <div class="modal" style="max-width: 520px;">
        <div class="modal__header">
          <span class="modal__title">Admin dev tools</span>
          <a href="#" class="modal__close" @click.prevent="close"><i class="fa fa-times"></i></a>
        </div>
        <div class="modal__body">
          <p style="margin-bottom: 12px; font-size: 0.9rem; color: #555;">
            Non-production only. Prepare sets consultation/order/prescription for refill testing. Charge runs payment only (no send to pharmacy).
          </p>

          <div style="margin-bottom: 16px;">
            <label style="display: block; margin-bottom: 4px;">Consultation ID</label>
            <input
              v-model="consultationId"
              type="text"
              class="input"
              style="width: 100%; max-width: 200px;"
              placeholder="e.g. 123"
            />
          </div>

          <div style="display: flex; gap: 8px; flex-wrap: wrap; margin-bottom: 16px;">
            <button
              type="button"
              class="button button-primary--small"
              :disabled="loading || !consultationId"
              @click="runPrepare"
            >
              Prepare refill
            </button>
            <button
              type="button"
              class="button button-primary--small"
              :disabled="loading || !consultationId"
              @click="runCharge"
            >
              Charge refill
            </button>
          </div>

          <div v-if="message" :style="messageStyle" style="margin-bottom: 12px; white-space: pre-wrap;">
            {{ message }}
          </div>

          <pre v-if="jsonPreview" style="background: #f5f5f5; padding: 12px; overflow: auto; max-height: 280px; font-size: 12px;">{{ jsonPreview }}</pre>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'AdminDevToolsModal',
  props: {
    csrfToken: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      open: false,
      consultationId: '',
      loading: false,
      message: '',
      messageOk: false,
      lastResponse: null,
    };
  },
  computed: {
    jsonPreview() {
      if (!this.lastResponse) {
        return '';
      }
      try {
        return JSON.stringify(this.lastResponse, null, 2);
      } catch (e) {
        return String(this.lastResponse);
      }
    },
    messageStyle() {
      return {
        color: this.messageOk ? '#1a7f37' : '#b00020',
      };
    },
  },
  methods: {
    close() {
      this.open = false;
    },
    async post(url) {
      this.loading = true;
      this.message = '';
      this.messageOk = false;
      this.lastResponse = null;

      try {
        const response = await axios.post(
          url,
          {
            consultation_id: parseInt(this.consultationId, 10),
            _token: this.csrfToken,
          },
          {
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
              'X-CSRF-TOKEN': this.csrfToken,
            },
          }
        );

        this.lastResponse = response.data;
        if (response.data && response.data.success) {
          this.messageOk = true;
          this.message = 'OK';
        } else {
          this.message = (response.data && response.data.message) || 'Request failed.';
        }
      } catch (error) {
        const data = error.response && error.response.data;
        this.lastResponse = data || { error: error.message };
        this.message =
          (data && data.message) ||
          (error.response && error.response.statusText) ||
          error.message ||
          'Request failed.';
      } finally {
        this.loading = false;
      }
    },
    runPrepare() {
      this.post('/dashboard/dev-tools/prepare-refill');
    },
    runCharge() {
      this.post('/dashboard/dev-tools/charge-refill');
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/AdminDevToolsModal.vue